export const BUILD_VERSION = '1792714493';
